/** @jsx jsx */
import { useDispatch } from 'react-redux'
import { jsx, css } from '@emotion/core'
import { Icon } from '@material-ui/core'
import { Icon as MaterialIcon } from '@mdi/react'
import { mdiClose } from '@mdi/js'
import { checkMessagesAndMarkAsRead } from '../../store/messages/actions'

import { closeTriggerNonActiveBoxShadow, closeTriggerActiveBoxShadow } from '../../styles/boxShadows'
import { SSPX } from '../../constants/themeConstants'
import { smartColors } from '../../styles/colors'

const TriggerCloseButton = () => {
	const dispatch = useDispatch()

	const handleMarkAsRead = () => {
		dispatch(checkMessagesAndMarkAsRead(true))
	}

	return (
		<Icon fontSize="small" css={iconCloseCss} onClick={handleMarkAsRead} data-testid="triggerClose">
			<MaterialIcon path={mdiClose} size={1} />
		</Icon>
	)
}

export default TriggerCloseButton

const iconCloseCss = css({
	borderRadius: '50%',
	cursor: 'pointer',
	padding: '2px',
	width: `${2.5 * SSPX}px`,
	height: `${2.5 * SSPX}px`,
	fontSize: `${2.5 * SSPX}px`,
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	border: `2px solid ${smartColors.white}`,
	color: smartColors.white,
	background: smartColors.grey,
	boxShadow: closeTriggerNonActiveBoxShadow,
	transition: 'all 0.2s',
	'&:hover': {
		boxShadow: closeTriggerActiveBoxShadow,
		transition: 'all 0.2s',
	},
})
